<template>
  <div>
    <v-row class="mb-4">
      <v-col>
        <h3 class="text-h6 font-weight-medium mb-4">
          Profile Information
        </h3>
        <p class="text--secondary">
          View your account details and update your contact information.
        </p>
      </v-col>
    </v-row>

    <v-form
      ref="profileForm"
      v-model="valid"
      @submit.prevent="handleSubmit"
    >
      <!-- Name (read-only, sourced from API) -->
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            :value="profile.firstName"
            label="First Name"
            outlined
            readonly
            disabled
            hint="Managed by your organization"
            persistent-hint
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            :value="profile.lastName"
            label="Last Name"
            outlined
            readonly
            disabled
            hint="Managed by your organization"
            persistent-hint
          />
        </v-col>
      </v-row>

      <!-- Email (read-only) and Phone (editable, stored in Firestore) -->
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            :value="profile.email"
            label="Email Address"
            outlined
            readonly
            disabled
            hint="Your sign-in email cannot be changed here"
            persistent-hint
            type="email"
          />
        </v-col>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="localProfile.phone"
            label="Phone Number"
            outlined
            :rules="phoneRules"
            hint="Stored in your profile"
            persistent-hint
          />
        </v-col>
      </v-row>

      <!-- Job Title (editable, stored in Firestore) and Department (read-only, from API) -->
      <v-row>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="localProfile.title"
            label="Job Title"
            outlined
            hint="Stored in your profile"
            persistent-hint
          />
        </v-col>
        <v-col
          v-if="department"
          cols="12"
          md="6"
        >
          <v-text-field
            :value="department"
            label="Department"
            outlined
            readonly
            disabled
            :loading="loadingDepartment"
            hint="Based on your team assignment"
            persistent-hint
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col class="d-flex justify-end">
          <v-btn
            color="primary"
            :disabled="!valid || !hasChanges"
            :loading="loading"
            @click="handleSubmit"
          >
            <font-awesome-icon
              :icon="['fas', 'floppy-disk']"
              class="mr-2"
            />
            Update Profile
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
export default {
  name: 'SettingsProfile',
  props: {
    profile: {
      type: Object,
      default: () => ({}),
    },
    department: {
      type: String,
      default: '',
    },
    loadingDepartment: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: false,
      localProfile: {
        phone: '',
        title: '',
      },
      phoneRules: [
        (v) => !v || /^[\d\s\-()+]+$/.test(v) || 'Phone number must be valid',
      ],
    }
  },
  computed: {
    hasChanges() {
      return this.localProfile.phone !== (this.profile.phone || '')
        || this.localProfile.title !== (this.profile.title || '')
    },
  },
  watch: {
    profile: {
      handler(newProfile) {
        this.localProfile = {
          phone: newProfile.phone || '',
          title: newProfile.title || '',
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleSubmit() {
      if (this.valid && this.hasChanges) {
        this.$emit('update', this.localProfile)
      }
    },
  },
}
</script>
